/*
  NDZ (07/10/2026, seconda versione): «Crea la tua box» (sections/noodz-box.liquid).
  Nei testi dei file di lingua i valori sono fra quadre, [n], [totale], [sconto], [prezzo], [prodotto]: non con le
  graffe, che il filtro t di Liquid proverebbe a riempire.
  Stato: quantità per gusto e per spezia. Ogni cambio ridisegna i posti della box (ogni kit col suo pacco, nell'ordine
  in cui è stato aggiunto), la barra coi traguardi, le pillole dei gusti, il riepilogo e il pulsante. Il pulsante si
  accende dal minimo; il carrello riceve tutto in una volta (/cart/add.js) e si apre il cassetto di Dawn.
  Lo sconto mostrato qui (impostazione «sconti») deve essere uguale allo sconto automatico di Shopify; si calcola
  pezzo per pezzo e per difetto al centesimo, come Shopify (4,29 € → 0,42 €).
*/
(function () {
  function avvia(radice) {
    var dati;
    try {
      dati = JSON.parse(radice.querySelector('[data-dati]').textContent);
    } catch (e) {
      return;
    }
    var t = dati.t;
    var minimo = Number(dati.minimo) || 6;
    var posti = Number(dati.posti) || 18;
    var rapidi = String(dati.rapidi || '').split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return n > 0; });
    var sconti = {};
    String(dati.sconti || '').split(',').forEach(function (c) {
      var p = c.split(':');
      if (p.length === 2) sconti[parseInt(p[0], 10)] = parseFloat(p[1]);
    });
    var colori = {};
    String(dati.colori || '').split(',').forEach(function (c) {
      var i = c.indexOf(':');
      if (i > 0) colori[c.slice(0, i).trim()] = c.slice(i + 1).trim();
    });
    var tariffe = String(dati.tariffe || '').split(',').map(function (c) {
      var p = c.trim().split(':');
      return { finoA: parseInt(p[0], 10), costo: parseInt(p[1], 10) };
    }).filter(function (x) { return !isNaN(x.finoA) && !isNaN(x.costo); });

    var gusti = {};
    var extra = {};
    var ordine = []; /* id dei kit nell'ordine in cui sono entrati nella box */
    dati.gusti.forEach(function (p) { gusti[p.id] = 0; });
    dati.extra.forEach(function (p) { extra[p.id] = 0; });
    var perId = {};
    dati.gusti.concat(dati.extra).forEach(function (p) { perId[p.id] = p; });
    var disponibili = dati.gusti.filter(function (p) { return p.disponibile; });

    function soldi(centesimi) {
      var parti = (centesimi / 100).toFixed(2).split('.');
      var conVirgola = parti[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parti[1];
      var conPunto = parti[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parti[1];
      return String(dati.moneta || '€{{amount_with_comma_separator}}')
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conVirgola)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parti[0])
        .replace(/\{\{\s*amount\s*\}\}/, conPunto)
        .replace(/<[^>]*>/g, '');
    }
    function testo(chiave, valori) {
      var s = t[chiave] || '';
      Object.keys(valori || {}).forEach(function (k) { s = s.split('[' + k + ']').join(valori[k]); });
      return s;
    }
    function quanti() { return ordine.length; }
    function scontoPer(n) {
      var m = 0;
      Object.keys(sconti).forEach(function (k) { if (n >= parseInt(k, 10) && sconti[k] > m) m = sconti[k]; });
      return m;
    }
    function spedizione(totale, peso) {
      if (dati.italia !== 'IT') return null;
      if (totale >= dati.soglia) return 0;
      for (var i = 0; i < tariffe.length; i++) if (peso <= tariffe[i].finoA) return tariffe[i].costo;
      return null;
    }
    function prezzoMedio() {
      var p = disponibili.length ? disponibili : dati.gusti;
      return p.length ? p.reduce(function (a, x) { return a + x.prezzo; }, 0) / p.length : 0;
    }
    /* quanti kit servono per la spedizione gratis (al prezzo medio) */
    var kitPerSped = Math.ceil(dati.soglia / (prezzoMedio() || 1));
    var tappe = [{ n: minimo, tipo: 'minimo', testo: testo('tappa_minimo', { n: minimo }), premio: t.premio_minimo }];
    if (kitPerSped > minimo) tappe.push({ n: kitPerSped, tipo: 'sped', testo: testo('tappa_sped', { n: kitPerSped }), premio: t.premio_sped });
    Object.keys(sconti).forEach(function (k) { tappe.push({ n: parseInt(k, 10), tipo: 'sconto', testo: testo('tappa_sconto', { n: k, sconto: sconti[k] }), premio: testo('premio_sconto', { sconto: sconti[k] }) }); });
    tappe.sort(function (a, b) { return a.n - b.n; });
    var massimoBarra = Math.max(posti, tappe[tappe.length - 1].n);

    function aggiungi(id) { gusti[id]++; ordine.push(id); }
    function togli(id) {
      if (!gusti[id]) return;
      gusti[id]--;
      var i = ordine.lastIndexOf(id);
      if (i >= 0) ordine.splice(i, 1);
    }

    /* ---------- Pillole dei gusti e delle spezie ---------- */
    function riga(p, isExtra) {
      var li = document.createElement('li');
      li.className = 'nbx__gusto' + (p.disponibile ? '' : ' nbx__gusto--esaurito');
      li.style.setProperty('--colore', colori[p.handle] || '#211F1C');
      li.innerHTML =
        '<img class="nbx__gusto-foto" src="' + (p.img || '') + '" alt="" width="56" height="56" loading="lazy">' +
        '<span class="nbx__gusto-testo"><a class="nbx__gusto-nome" href="' + p.url + '"></a><span class="nbx__gusto-sotto"></span></span>' +
        (p.disponibile
          ? '<span class="nbx__passi"><button type="button" class="nbx__meno">−</button><output class="nbx__n">0</output><button type="button" class="nbx__piu">+</button></span>'
          : '<span class="nbx__presto">' + t.torna_presto + '</span>');
      li.querySelector('.nbx__gusto-nome').textContent = p.titolo;
      li.querySelector('.nbx__gusto-sotto').textContent = soldi(p.prezzo) + (p.sotto ? ' · ' + p.sotto : '');
      if (p.disponibile) {
        var meno = li.querySelector('.nbx__meno'), piu = li.querySelector('.nbx__piu');
        meno.setAttribute('aria-label', testo('togli_uno', { prodotto: p.titolo }));
        piu.setAttribute('aria-label', testo('aggiungi_uno', { prodotto: p.titolo }));
        meno.addEventListener('click', function () { if (isExtra) { if (extra[p.id]) extra[p.id]--; } else togli(p.id); ridisegna(); });
        piu.addEventListener('click', function () { if (isExtra) extra[p.id]++; else aggiungi(p.id); ridisegna(); });
      }
      li.dataset.id = p.id;
      li.dataset.tipo = isExtra ? 'extra' : 'kit';
      return li;
    }
    var listaGusti = radice.querySelector('[data-lista-gusti]');
    dati.gusti.forEach(function (p) { listaGusti.appendChild(riga(p, false)); });
    var listaExtra = radice.querySelector('[data-lista-extra]');
    if (listaExtra) dati.extra.forEach(function (p) { listaExtra.appendChild(riga(p, true)); });

    /* ---------- Scelte rapide: N kit misti ---------- */
    var boxRapidi = radice.querySelector('[data-rapidi]');
    rapidi.forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nbx__rapido';
      b.textContent = testo('misti', { n: n });
      b.addEventListener('click', function () {
        Object.keys(gusti).forEach(function (k) { gusti[k] = 0; });
        ordine = [];
        for (var i = 0; i < n && disponibili.length; i++) aggiungi(disponibili[i % disponibili.length].id);
        ridisegna();
      });
      boxRapidi.appendChild(b);
    });

    /* stella a punte (quella rossa col bordo nero delle confezioni Just Noodz): poligono SVG */
    function stella(punte, est, int) {
      var pt = [];
      for (var i = 0; i < punte * 2; i++) {
        var r = i % 2 ? int : est, a = (Math.PI / punte) * i - Math.PI / 2;
        pt.push((Math.cos(a) * r).toFixed(1) + ',' + (Math.sin(a) * r).toFixed(1));
      }
      return '<svg viewBox="-56 -56 112 112" aria-hidden="true" focusable="false"><polygon points="' + pt.join(' ') + '"/></svg>';
    }

    /* ---------- Traguardi ---------- */
    var listaTappe = radice.querySelector('[data-tappe]');
    tappe.forEach(function (tp) {
      var li = document.createElement('li');
      li.className = 'nbx__tappa';
      li.style.setProperty('--pos', Math.min(100, (tp.n / massimoBarra) * 100) + '%');
      li.innerHTML = '<span class="nbx__stella">' + stella(14, 52, 42) + '<span class="nbx__stella-n">' + tp.n + '</span></span><span class="nbx__tappa-testo"></span>';
      li.dataset.tipo = tp.tipo;
      li.querySelector('.nbx__tappa-testo').textContent = tp.testo;
      li.dataset.n = tp.n;
      listaTappe.appendChild(li);
    });

    var elPosti = radice.querySelector('[data-posti]');
    var elVaso = radice.querySelector('[data-ciotola]'); /* la ciotola disegnata (stile «ciotola») */
    var elMessaggio = radice.querySelector('[data-messaggio]');
    var elPremio = radice.querySelector('[data-premio]');
    var prima = 0; /* quanti kit c'erano al disegno precedente: serve alle animazioni */
    var scontoMax = 0;
    Object.keys(sconti).forEach(function (k) { if (sconti[k] > scontoMax) scontoMax = sconti[k]; });
    var sogliaSconto = 0;
    Object.keys(sconti).forEach(function (k) { if (sconti[k] === scontoMax) sogliaSconto = parseInt(k, 10); });
    var elConta = radice.querySelector('[data-conta]');
    var elBarra = radice.querySelector('[data-barra]');
    var righe = radice.querySelector('[data-righe]');
    var elTotale = radice.querySelector('[data-totale]');
    var elCiotola = radice.querySelector('[data-a-ciotola]');
    var bottone = radice.querySelector('[data-aggiungi]');
    var errore = radice.querySelector('[data-errore]');

    /* fa ripartire un'animazione CSS sull'elemento */
    function riavvia(el, classe) {
      if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      el.classList.remove(classe);
      void el.offsetWidth;
      el.classList.add(classe);
    }

    /* ---------- La scatola: sempre «posti» caselle; oltre, l'ultima dice «+N» ---------- */
    function disegnaScatola(n) {
      elPosti.innerHTML = '';
      for (var i = 0; i < posti; i++) {
        var li = document.createElement('li');
        var id = ordine[i];
        if (n > posti && i === posti - 1) {
          li.className = 'nbx__posto nbx__posto--altri';
          li.textContent = testo('altri', { n: n - posti + 1 });
        } else if (id) {
          var p = perId[id];
          li.className = 'nbx__posto nbx__posto--pieno' + (n > prima && i === n - 1 ? ' nbx__posto--nuovo' : '');
          li.style.setProperty('--colore', colori[p.handle] || '#211F1C');
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', testo('togli_dalla_box', { prodotto: p.titolo }));
          b.innerHTML = '<img src="' + p.img + '" alt="" width="64" height="64">';
          (function (x) { b.addEventListener('click', function () { togli(x); ridisegna(); }); })(id);
          li.appendChild(b);
        } else {
          li.className = 'nbx__posto';
        }
        elPosti.appendChild(li);
      }
    }

    /* ---------- La ciotola: la ciotola del logo, all'insù; ogni kit è uno strato del colore del suo gusto.
       Tacche sul fianco ai traguardi; piena (posti kit) escono i noodle e il vapore. ---------- */
    function disegnaCiotola(n) {
      var W = 420, cimaY = 70, fondoY = 250, h = fondoY - cimaY;
      var strato = h / posti;
      var bordo = 'M30 ' + cimaY + ' H390 C390 185 310 250 210 250 C110 250 30 185 30 ' + cimaY + ' Z';
      var svg = '<svg class="nbx__ciotola-svg" viewBox="0 0 ' + W + ' 300" role="img" aria-label="' + testo('di', { n: n }) + '">' +
        '<defs><clipPath id="nbxDentro"><path d="' + bordo + '"/></clipPath></defs>' +
        '<path d="' + bordo + '" fill="#FFFEFA"/>' +
        '<g clip-path="url(#nbxDentro)">';
      for (var i = 0; i < Math.min(n, posti); i++) {
        var p = perId[ordine[i]];
        var y = fondoY - (i + 1) * strato;
        svg += '<rect class="nbx__strato' + (n > prima && i === n - 1 ? ' nbx__strato--nuovo' : '') + '" x="0" y="' + y.toFixed(1) + '" width="' + W + '" height="' + (strato + 0.6).toFixed(1) + '" fill="' + (colori[p.handle] || '#211F1C') + '" data-id="' + p.id + '"/>';
        svg += '<line x1="0" x2="' + W + '" y1="' + y.toFixed(1) + '" y2="' + y.toFixed(1) + '" stroke="#211F1C" stroke-opacity=".18" stroke-width="1"/>';
      }
      svg += '</g>';
      /* tacche dei traguardi */
      tappe.forEach(function (tp) {
        if (tp.n > posti) return;
        var y = fondoY - tp.n * strato;
        var fatta = n >= tp.n;
        svg += '<line class="nbx__tacca" x1="36" x2="384" y1="' + y + '" y2="' + y + '" stroke="#211F1C" stroke-width="2" stroke-dasharray="6 6"/>' +
          '<text class="nbx__tacca-n' + (fatta ? ' nbx__tacca-n--fatta' : '') + '" x="' + (W - 4) + '" y="' + (y - 6) + '" text-anchor="end">' + tp.n + '</text>';
      });
      /* bordo, orlo e piede */
      svg += '<path d="' + bordo + '" fill="none" stroke="#211F1C" stroke-width="6" stroke-linejoin="round"/>' +
        '<path d="M14 ' + cimaY + ' H406" stroke="#211F1C" stroke-width="12" stroke-linecap="round"/>' +
        '<path d="M160 250 H260 L250 270 H170 Z" fill="#211F1C"/>';
      /* piena: noodle e vapore */
      if (n >= posti) {
        svg += '<g class="nbx__noodle" fill="none" stroke="#F2D9A0" stroke-width="7" stroke-linecap="round">' +
          '<path d="M90 64 C120 40 150 80 180 56 S240 40 270 62 S320 70 340 54"/>' +
          '<path d="M110 66 C140 52 170 86 200 60 S260 50 300 66"/></g>' +
          '<g class="nbx__vapore" fill="none" stroke="#211F1C" stroke-width="4" stroke-linecap="round" stroke-opacity=".55">' +
          '<path d="M150 40 C140 25 160 15 150 0"/><path d="M210 36 C200 21 220 11 210 -4"/><path d="M270 40 C260 25 280 15 270 0"/></g>';
      }
      svg += '</svg>';
      var vecchio = elVaso.querySelector('svg');
      if (vecchio) vecchio.remove();
      elVaso.insertAdjacentHTML('afterbegin', svg);
      elVaso.querySelectorAll('.nbx__strato').forEach(function (r) {
        r.addEventListener('click', function () { togli(Number(r.getAttribute('data-id'))); ridisegna(); });
      });
      if (n > posti) elVaso.querySelector('.nbx__ciotola-conta').setAttribute('data-oltre', testo('altri', { n: n - posti }));
      else elVaso.querySelector('.nbx__ciotola-conta').removeAttribute('data-oltre');
    }

    function rigaRiepilogo(etichetta, valore) {
      var d = document.createElement('div');
      var dt = document.createElement('dt'); dt.textContent = etichetta;
      var dd = document.createElement('dd'); dd.textContent = valore;
      d.appendChild(dt); d.appendChild(dd);
      righe.appendChild(d);
    }

    function ridisegna() {
      var n = quanti();

      if (elPosti) disegnaScatola(n);
      if (elVaso) disegnaCiotola(n);
      elConta.textContent = testo('di', { n: n });
      if (n !== prima) riavvia(elConta, 'nbx--sobbalza');

      /* messaggio sopra la barra: quanto manca al prossimo traguardo */
      var msg;
      if (!n) msg = t.msg_vuota;
      else if (n < minimo) msg = testo('msg_parti', { n: minimo - n, min: minimo });
      else if (n < kitPerSped) msg = testo('msg_sped', { n: kitPerSped - n });
      else if (sogliaSconto && n < sogliaSconto) msg = testo('msg_sconto', { n: sogliaSconto - n, sconto: scontoMax });
      else msg = testo('msg_completa', { sconto: scontoMax });
      if (elMessaggio.textContent !== msg) {
        elMessaggio.textContent = msg;
        riavvia(elMessaggio, 'nbx--nuovo-messaggio');
      }

      /* barra e traguardi */
      elBarra.style.width = Math.min(100, (n / massimoBarra) * 100) + '%';
      var premio = null;
      listaTappe.querySelectorAll('.nbx__tappa').forEach(function (li, i) {
        var soglia = Number(li.dataset.n);
        li.classList.toggle('nbx__tappa--fatta', n >= soglia);
        if (prima < soglia && n >= soglia) {
          riavvia(li, 'nbx__tappa--scatta');
          premio = tappe[i].premio; /* se ne passano più insieme, vince l'ultimo */
        }
      });
      if (premio && elPremio) {
        elPremio.innerHTML = stella(18, 54, 45) + '<span class="nbx__premio-testo"></span>';
        elPremio.querySelector('.nbx__premio-testo').textContent = premio;
        riavvia(elPremio, 'nbx__premio--mostra');
      }

      /* pillole */
      radice.querySelectorAll('.nbx__gusto').forEach(function (li) {
        var out = li.querySelector('.nbx__n');
        if (!out) return;
        var q = li.dataset.tipo === 'extra' ? extra[li.dataset.id] : gusti[li.dataset.id];
        out.textContent = q;
        li.classList.toggle('nbx__gusto--scelto', q > 0);
        li.querySelector('.nbx__meno').disabled = q === 0;
      });

      /* conti */
      var kitTot = 0, peso = 0, extraTot = 0;
      dati.gusti.forEach(function (p) { kitTot += p.prezzo * gusti[p.id]; peso += p.peso * gusti[p.id]; });
      dati.extra.forEach(function (p) { extraTot += p.prezzo * extra[p.id]; peso += p.peso * extra[p.id]; });
      var pct = scontoPer(n), sconto = 0;
      dati.gusti.forEach(function (p) { sconto += Math.floor(p.prezzo * pct / 100) * gusti[p.id]; });
      var prodotti = kitTot - sconto + extraTot;
      var sped = n || extraTot ? spedizione(prodotti, peso) : null;
      var totale = prodotti + (sped || 0);

      righe.innerHTML = '';
      rigaRiepilogo(testo('ramen_kit', { n: n }), soldi(kitTot));
      if (sconto) rigaRiepilogo(testo('sconto_box', { sconto: pct }), '−' + soldi(sconto));
      if (extraTot) rigaRiepilogo(t.spezie, soldi(extraTot));
      if (sped !== null) rigaRiepilogo(t.spedizione, sped === 0 ? t.gratis : soldi(sped));
      elTotale.textContent = soldi(totale);
      elCiotola.textContent = n ? testo('a_ciotola', { prezzo: soldi(Math.round((kitTot - sconto + (sped || 0)) / n)) }) : '';

      riavvia(elTotale, 'nbx--sobbalza');
      prima = n;
      var mancano = minimo - n;
      bottone.disabled = n < minimo;
      bottone.textContent = n >= minimo ? testo('aggiungi', { n: n }) : mancano === 1 ? t.manca_uno : testo('mancano', { n: mancano });
    }

    /* ---------- Nel carrello ---------- */
    bottone.addEventListener('click', function () {
      var articoli = [];
      Object.keys(gusti).forEach(function (k) { if (gusti[k]) articoli.push({ id: Number(k), quantity: gusti[k] }); });
      Object.keys(extra).forEach(function (k) { if (extra[k]) articoli.push({ id: Number(k), quantity: extra[k] }); });
      if (!articoli.length) return;
      var cassetto = document.querySelector('cart-drawer');
      bottone.disabled = true;
      bottone.setAttribute('aria-busy', 'true');
      errore.hidden = true;
      var corpo = { items: articoli };
      if (cassetto) {
        corpo.sections = cassetto.getSectionsToRender().map(function (s) { return s.id; });
        corpo.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corpo)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || '');
          bottone.textContent = t.aggiunta;
          if (cassetto && res.j.sections) {
            cassetto.classList.remove('is-empty');
            cassetto.renderContents(res.j);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (e) {
          errore.textContent = t.errore + (e && e.message ? ' (' + e.message + ')' : '');
          errore.hidden = false;
        })
        .finally(function () {
          bottone.removeAttribute('aria-busy');
          ridisegna();
        });
    });

    ridisegna();
  }

  document.querySelectorAll('[data-noodz-box]').forEach(avvia);
})();
